import React, { useEffect, useMemo, useState } from "react";
import "../Landing/index.css";
import "./index.css";
import MenuIcon from "@mui/icons-material/Menu";
import { buildWhatsappUrl } from "../Landing/utm";

const MAIN_SITE = "https://comabooks.org";

type DocKey = "privacy" | "terms" | "offer";

type Section = {
  id: string;
  title: string;
  content: React.ReactNode;
};

type Document = {
  key: DocKey;
  label: string;
  title: string;
  intro?: string;
  sections: Section[];
};

const documents: Document[] = [
  {
    key: "privacy",
    label: "Политика конфиденциальности",
    title: "Политика конфиденциальности",
    intro:
      "Мы обязуемся защищать конфиденциальность ваших персональных данных. Ниже описано, как мы собираем, используем и защищаем информацию о пользователях нашего сайта.",
    sections: [
      {
        id: "privacy-1",
        title: "1. Введение",
        content: (
          <p>
            Мы, Comabooks Publishing House (юридическое лицо ТОО «COMABOOKS»),
            обязуемся защищать конфиденциальность ваших персональных данных.
            Данная политика конфиденциальности объясняет, как мы собираем,
            используем и защищаем информацию о пользователях нашего сайта.
          </p>
        ),
      },
      {
        id: "privacy-2",
        title: "2. Сбор данных",
        content: (
          <>
            <p>Мы собираем следующие типы данных:</p>
            <ul>
              <li>
                <b>Персональные данные:</b> имя, адрес электронной почты и
                другие контактные данные, которые вы предоставляете при создании
                аккаунта.
              </li>
              <li>
                <b>Ответы на вопросы:</b> информация, которую вы предоставляете
                при ответе на вопросы для создания персонализированной книги.
              </li>
              <li>
                <b>Фотографии:</b> изображения, которые вы загружаете для
                включения в книгу.
              </li>
              <li>
                <b>Выбор обложки:</b> ваши предпочтения относительно дизайна
                обложки книги.
              </li>
            </ul>
          </>
        ),
      },
      {
        id: "privacy-3",
        title: "3. Использование данных",
        content: (
          <>
            <p>Мы используем собранные данные для:</p>
            <ul>
              <li>создания вашей персонализированной книги;</li>
              <li>обработки ваших заказов и управления вашим аккаунтом;</li>
              <li>улучшения нашего сайта и услуг.</li>
            </ul>
          </>
        ),
      },
      {
        id: "privacy-4",
        title: "4. Конфиденциальность, редактура и раскрытие данных",
        content: (
          <p>
            Содержание вашей книги видят только вы и наш редактор. Вы можете
            отказаться от редактуры, и ваш материал останется полностью
            анонимным.
          </p>
        ),
      },
      {
        id: "privacy-5",
        title: "5. Отказ от ответственности и безопасность данных",
        content: (
          <p>
            Мы прилагаем все усилия для защиты ваших данных, но не можем
            гарантировать их абсолютную безопасность в интернете. В случае
            взлома нашего сайта мы не несём ответственности за утечку ваших
            персональных данных. Мы применяем различные меры безопасности для
            защиты персональных данных, включая электронные, физические и
            управленческие процедуры.
          </p>
        ),
      },
      {
        id: "privacy-6",
        title: "6. Права пользователя",
        content: (
          <p>
            Вы имеете право в любое время запросить доступ к своим персональным
            данным, их исправление, удаление или ограничение обработки. Также
            вы имеете право возражать против обработки ваших данных и запросить
            их передачу.
          </p>
        ),
      },
      {
        id: "privacy-7",
        title: "7. Изменения в политике конфиденциальности",
        content: (
          <p>
            Мы можем обновлять нашу политику конфиденциальности периодически.
            Мы уведомим вас о любых изменениях, разместив новую редакцию на
            этой странице.
          </p>
        ),
      },
      {
        id: "privacy-8",
        title: "8. Контактная информация",
        content: (
          <p>
            Если у вас есть вопросы относительно этой политики
            конфиденциальности, вы можете связаться с нами по телефону{" "}
            <b>+7 (747) 673-84-27</b>.
          </p>
        ),
      },
    ],
  },
  {
    key: "terms",
    label: "Условия использования",
    title: "Условия использования",
    intro:
      "Правила использования сайта comabooks.org. Условия оказания услуг и порядок возврата определяются Публичной офертой.",
    sections: [
      {
        id: "terms-1",
        title: "1. Общие положения",
        content: (
          <>
            <p>
              Настоящая политика определяет правила использования сайта
              comabooks.org, принадлежащего ТОО «COMABOOKS». Используя сайт, вы
              подтверждаете согласие с настоящими правилами. Если вы не
              согласны с какими-либо условиями, пожалуйста, прекратите
              использование сайта.
            </p>
            <p>
              Условия оказания услуг, их стоимость и порядок возврата
              определяются Публичной офертой, размещённой на сайте.
            </p>
          </>
        ),
      },
      {
        id: "terms-2",
        title: "2. Авторские права и интеллектуальная собственность",
        content: (
          <p>
            Все материалы на сайте, включая текст, графику, логотипы, иконки,
            изображения, аудио- и видеоклипы, являются собственностью ТОО
            «COMABOOKS» или его контент-поставщиков и защищены
            законодательством Республики Казахстан об авторских правах.
            Никакие материалы сайта не могут быть скопированы, воспроизведены,
            переданы или распространены без предварительного письменного
            разрешения ТОО «COMABOOKS».
          </p>
        ),
      },
      {
        id: "terms-3",
        title: "3. Лицензия на использование",
        content: (
          <>
            <p>
              ТОО «COMABOOKS» предоставляет вам ограниченную лицензию на доступ
              и личное использование сайта. Эта лицензия не включает:
            </p>
            <ul>
              <li>
                перепродажу или коммерческое использование сайта или его
                содержимого;
              </li>
              <li>
                сбор и использование любых каталогов, описаний продуктов или
                цен;
              </li>
              <li>производное использование сайта или его содержимого;</li>
              <li>
                загрузку или копирование информации в пользу третьей стороны;
              </li>
              <li>
                любое использование средств автоматизированного сбора и
                извлечения данных.
              </li>
            </ul>
          </>
        ),
      },
      {
        id: "terms-4",
        title: "4. Ваш аккаунт",
        content: (
          <p>
            Если вы используете сайт, вы несёте ответственность за поддержание
            конфиденциальности своего аккаунта и пароля, а также за ограничение
            доступа к вашему устройству. Вы соглашаетесь принять ответственность
            за все действия, совершённые под вашим аккаунтом.
          </p>
        ),
      },
      {
        id: "terms-5",
        title: "5. Пользовательский контент",
        content: (
          <p>
            Размещая материалы на сайте (тексты, фотографии), вы подтверждаете,
            что обладаете необходимыми правами на данные материалы. Запрещается
            размещение контента, который является незаконным, оскорбительным,
            нарушает права третьих лиц или содержит вредоносное программное
            обеспечение.
          </p>
        ),
      },
      {
        id: "terms-6",
        title: "6. Изменения условий использования",
        content: (
          <p>
            Мы можем вносить изменения в настоящие условия использования, при
            этом обязуемся уведомлять пользователей посредством публикации
            обновлённой редакции на сайте не позднее чем за 2 календарных дня
            до вступления изменений в силу. Продолжение использования сайта
            после вступления изменений в силу означает согласие с новыми
            условиями.
          </p>
        ),
      },
      {
        id: "terms-7",
        title: "7. Контактная информация",
        content: (
          <p>
            По вопросам, связанным с использованием сайта, свяжитесь с нами по
            телефону <b>+7 (747) 673-84-27</b>.
          </p>
        ),
      },
    ],
  },
  {
    key: "offer",
    label: "Публичная оферта",
    title: "Публичная оферта",
    intro:
      "Публичная оферта о договоре оказания услуг по созданию персонализированной книги. г. Алматы.",
    sections: [
      {
        id: "offer-1",
        title: "1. Общие положения",
        content: (
          <>
            <p>
              1.1. Настоящий документ является официальным предложением
              (публичной офертой) ТОО «COMABOOKS» (далее — «Исполнитель»),
              адресованным неопределённому кругу лиц (далее — «Заказчик»), и
              содержит все существенные условия договора оказания услуг по
              созданию персонализированной книги в соответствии со статьями
              395–397 Гражданского кодекса Республики Казахстан.
            </p>
            <p>
              1.2. Акцептом (принятием) настоящей оферты является оплата
              Заказчиком услуг Исполнителя любым из способов, указанных на
              сайте. Момент оплаты считается моментом заключения договора между
              Исполнителем и Заказчиком.
            </p>
            <p>
              1.3. Оферта действует с момента её публикации на сайте
              comabooks.org и действует до момента её отзыва Исполнителем.
            </p>
            <p>
              1.4. Исполнитель вправе вносить изменения в условия оферты.
              Изменения вступают в силу с момента публикации новой редакции на
              сайте. Заказы, оплаченные до вступления изменений в силу,
              выполняются на прежних условиях.
            </p>
          </>
        ),
      },
      {
        id: "offer-2",
        title: "2. Термины и определения",
        content: (
          <>
            <p>
              2.1. <b>Сайт</b> — интернет-ресурс, расположенный по адресу
              comabooks.org.
            </p>
            <p>
              2.2. <b>Персонализированная книга</b> — печатное издание,
              созданное на основе ответов, фотографий и предпочтений Заказчика,
              являющееся уникальным экземпляром.
            </p>
            <p>
              2.3. <b>Личный кабинет</b> — защищённый раздел Сайта, доступ к
              которому предоставляется Заказчику после оплаты услуги «Создание
              аккаунта», предназначенный для заполнения материалов книги.
            </p>
          </>
        ),
      },
      {
        id: "offer-3",
        title: "3. Предмет договора",
        content: (
          <>
            <p>
              3.1. Исполнитель обязуется оказать Заказчику услуги по созданию
              персонализированной книги и её доставку, а Заказчик обязуется
              оплатить указанные услуги в порядке и на условиях, предусмотренных
              настоящей офертой.
            </p>
            <p>3.2. Услуги Исполнителя включают следующие этапы:</p>
            <ul>
              <li>
                <b>Создание аккаунта</b> — предоставление Заказчику доступа к
                Личному кабинету для заполнения материалов книги (ответы на
                вопросы, загрузка фотографий, выбор обложки).
              </li>
              <li>
                <b>Редактура</b> — корректура текста, стилистическая обработка,
                вёрстка и подготовка макета книги.
              </li>
              <li>
                <b>Печать</b> — изготовление уникального экземпляра книги.
              </li>
              <li>
                <b>Доставка</b> — отправка готовой книги Заказчику посредством
                курьерской службы.
              </li>
            </ul>
          </>
        ),
      },
      {
        id: "offer-4",
        title: "4. Стоимость услуг и порядок оплаты",
        content: (
          <>
            <p>4.1. Стоимость услуг составляет:</p>
            <ul>
              <li>Создание аккаунта — 5 000 ₸ (пять тысяч тенге);</li>
              <li>Редактура — 20 000 ₸ (двадцать тысяч тенге);</li>
              <li>Печать — 14 000 ₸ (четырнадцать тысяч тенге).</li>
            </ul>
            <p>
              4.2. Итоговая стоимость услуг составляет 39 000 ₸ (тридцать девять
              тысяч тенге). Стоимость доставки не входит в указанную сумму и
              рассчитывается отдельно в зависимости от адреса и тарифов
              курьерской службы.
            </p>
            <p>
              4.3. Все цены на Сайте указаны в тенге (₸). При оплате в иной
              валюте итоговая сумма может отличаться от указанной на Сайте в
              связи с колебаниями валютного курса и комиссиями платёжных систем.
            </p>
            <p>
              4.4. Оплата производится в полном объёме до начала оказания услуг
              способами, доступными на Сайте.
            </p>
          </>
        ),
      },
      {
        id: "offer-5",
        title: "5. Порядок оказания услуг",
        content: (
          <>
            <p>
              5.1. После оплаты Заказчику предоставляется доступ к Личному
              кабинету (логин и пароль). Услуга «Создание аккаунта» считается
              оказанной в момент предоставления доступа.
            </p>
            <p>
              5.2. Заказчик самостоятельно заполняет материалы книги в Личном
              кабинете: отвечает на вопросы, загружает фотографии, выбирает
              дизайн обложки.
            </p>
            <p>
              5.3. После завершения заполнения Заказчик нажимает кнопку
              «Завершить» (либо иным образом сообщает о готовности материала). С
              этого момента начинается процесс редактуры.
            </p>
            <p>
              5.4. Срок выполнения заказа (редактура, печать, передача
              курьерской службе) составляет до 21 (двадцати одного) рабочего
              дня с момента нажатия Заказчиком кнопки «Завершить».
            </p>
            <p>
              5.5. Содержание книги доступно только Заказчику и редактору
              Исполнителя. Заказчик вправе отказаться от редактуры, в таком
              случае материал публикуется в авторском виде.
            </p>
          </>
        ),
      },
      {
        id: "offer-6",
        title: "6. Доставка",
        content: (
          <>
            <p>
              6.1. Доставка осуществляется курьерскими службами (Казпочта, СДЭК
              и др.) по адресу, указанному Заказчиком при оформлении заказа.
            </p>
            <p>
              6.2. Стоимость доставки определяется тарифами курьерской службы и
              оплачивается Заказчиком дополнительно.
            </p>
            <p>
              6.3. Сроки доставки зависят от региона и условий курьерской
              службы. Исполнитель не несёт ответственности за задержки,
              вызванные действиями курьерской службы.
            </p>
            <p>
              6.4. Риск случайной гибели или повреждения книги переходит к
              Заказчику с момента передачи книги курьерской службе.
            </p>
          </>
        ),
      },
      {
        id: "offer-7",
        title: "7. Возврат и отказ от услуг",
        content: (
          <>
            <p>
              7.1. Стоимость услуги «Создание аккаунта» (5 000 ₸) не подлежит
              возврату, поскольку доступ создаётся индивидуально и позволяет
              немедленно приступить к работе над книгой.
            </p>
            <p>
              7.2. Если Заказчик запрашивает возврат до начала процесса
              редактуры, стоимость услуг «Редактура» и «Печать» (34 000 ₸)
              возвращается в полном объёме.
            </p>
            <p>
              7.3. Процесс редактуры считается начатым с момента, когда Заказчик
              нажимает кнопку «Завершить» либо иным способом сообщает о
              готовности материала. С этого момента возврат стоимости услуги
              «Редактура» не осуществляется.
            </p>
            <p>
              7.4. Если после начала редактуры Заказчик отказывается от печати,
              возврат осуществляется только за услугу «Печать» в размере
              14 000 ₸.
            </p>
            <p>
              7.5. Для запроса возврата Заказчик связывается с Исполнителем
              любым доступным способом (телефон, электронная почта,
              мессенджеры) с указанием логина, даты покупки и причины возврата.
              Возврат денежных средств осуществляется в течение 14
              (четырнадцати) календарных дней с момента одобрения запроса.
            </p>
          </>
        ),
      },
      {
        id: "offer-8",
        title: "8. Права и обязанности сторон",
        content: (
          <>
            <h4>Исполнитель обязан:</h4>
            <ul>
              <li>оказать услуги надлежащего качества в установленные сроки;</li>
              <li>
                обеспечить конфиденциальность персональных данных и материалов
                Заказчика;
              </li>
              <li>
                уведомить Заказчика о готовности заказа и передаче его
                курьерской службе.
              </li>
            </ul>
            <h4>Исполнитель вправе:</h4>
            <ul>
              <li>
                изменять условия оферты в одностороннем порядке с публикацией
                изменений на Сайте;
              </li>
              <li>
                привлекать третьих лиц для выполнения отдельных этапов услуг
                (печать, доставка).
              </li>
            </ul>
            <h4>Заказчик обязан:</h4>
            <ul>
              <li>
                предоставить достоверные данные для создания книги и доставки;
              </li>
              <li>оплатить услуги в полном объёме;</li>
              <li>
                не использовать Сайт для размещения незаконного, оскорбительного
                или нарушающего права третьих лиц контента;
              </li>
              <li>
                обеспечить конфиденциальность своих учётных данных (логина и
                пароля).
              </li>
            </ul>
            <h4>Заказчик вправе:</h4>
            <ul>
              <li>запрашивать информацию о статусе заказа;</li>
              <li>отказаться от редактуры материала;</li>
              <li>
                запросить возврат денежных средств в соответствии с разделом 7
                настоящей оферты.
              </li>
            </ul>
          </>
        ),
      },
      {
        id: "offer-9",
        title: "9. Ответственность сторон",
        content: (
          <>
            <p>
              9.1. Исполнитель прилагает все разумные усилия для защиты
              персональных данных Заказчика, однако не несёт ответственности за
              утечку данных вследствие несанкционированного доступа третьих лиц.
            </p>
            <p>
              9.2. Исполнитель не несёт ответственности за содержание
              материалов, предоставленных Заказчиком. Ответственность за
              достоверность и законность материалов несёт Заказчик.
            </p>
            <p>
              9.3. Заказчик несёт ответственность за все действия, совершённые
              под его учётными данными (логином и паролем).
            </p>
          </>
        ),
      },
      {
        id: "offer-10",
        title: "10. Персональные данные",
        content: (
          <>
            <p>
              10.1. Акцептуя настоящую оферту, Заказчик даёт согласие на сбор и
              обработку персональных данных в объёме, необходимом для
              исполнения обязательств по настоящему договору, в соответствии с
              Законом Республики Казахстан «О персональных данных и их защите».
            </p>
            <p>
              10.2. Порядок сбора, хранения и защиты персональных данных
              определяется Политикой конфиденциальности, размещённой на Сайте.
            </p>
            <p>
              10.3. Заказчик вправе в любое время запросить доступ к своим
              персональным данным, их исправление, удаление или ограничение
              обработки.
            </p>
          </>
        ),
      },
      {
        id: "offer-11",
        title: "11. Интеллектуальная собственность",
        content: (
          <>
            <p>
              11.1. Все материалы Сайта (тексты, графика, логотипы, изображения,
              дизайн) являются собственностью Исполнителя и защищены
              законодательством Республики Казахстан об авторских правах.
            </p>
            <p>
              11.2. Материалы, предоставленные Заказчиком (тексты, фотографии),
              остаются его собственностью. Исполнитель использует их
              исключительно для выполнения заказа.
            </p>
          </>
        ),
      },
      {
        id: "offer-12",
        title: "12. Обстоятельства непреодолимой силы",
        content: (
          <p>
            12.1. Стороны освобождаются от ответственности за неисполнение или
            ненадлежащее исполнение обязательств, если это явилось следствием
            обстоятельств непреодолимой силы: стихийные бедствия, военные
            действия, акты государственных органов, массовые сбои в работе сети
            Интернет и иные обстоятельства, не зависящие от воли сторон.
          </p>
        ),
      },
      {
        id: "offer-13",
        title: "13. Разрешение споров",
        content: (
          <p>
            13.1. Все споры и разногласия разрешаются путём переговоров. В
            случае недостижения согласия спор подлежит рассмотрению в суде по
            месту нахождения Исполнителя в соответствии с законодательством
            Республики Казахстан.
          </p>
        ),
      },
      {
        id: "offer-14",
        title: "14. Заключительные положения",
        content: (
          <>
            <p>
              14.1. Настоящая оферта регулируется законодательством Республики
              Казахстан.
            </p>
            <p>
              14.2. Во всём, что не предусмотрено настоящей офертой, стороны
              руководствуются действующим законодательством Республики
              Казахстан.
            </p>
            <p>
              14.3. Признание недействительным отдельного положения оферты не
              влечёт недействительности остальных положений.
            </p>
          </>
        ),
      },
      {
        id: "offer-15",
        title: "15. Реквизиты Исполнителя",
        content: (
          <div className="policy-reqs">
            <div>
              <b>ТОО «COMABOOKS»</b>
            </div>
            <div>БИН: 250140019272</div>
            <div>Юридический адрес: г. Алматы</div>
            <div>Телефон: +7 (747) 673-84-27</div>
            <div>Сайт: comabooks.org</div>
          </div>
        ),
      },
    ],
  },
];

const tabOrder: Document[] = (["offer", "privacy", "terms"] as DocKey[]).map(
  (k) => documents.find((d) => d.key === k)!
);

function Policy() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [phone, setPhone] = useState<string>("");
  const [activeDoc, setActiveDoc] = useState<DocKey>("offer");

  const toggleNav = () => setIsNavVisible((v) => !v);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    async function fetchPhone() {
      try {
        const res = await fetch("https://api.comabooks.org/sales/phoneNumber");
        if (!res.ok) throw new Error("Не удалось получить номер");
        const data = await res.json();
        setPhone(data || "");
      } catch (err) {
        console.error(err);
      }
    }
    fetchPhone();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeDoc]);

  const handleOrder = () => {
    const whatsappUrl = buildWhatsappUrl(phone);
    window.open(whatsappUrl, "_blank");
  };

  const current = useMemo(
    () => documents.find((d) => d.key === activeDoc)!,
    [activeDoc]
  );

  return (
    <div className="l-page policy-page">
      {/* Header */}
      <header className="l-header">
        <div className={`l-header-pill ${isScrolled ? "scrolled" : ""}`}>
          <a className="l-logo" href={`${MAIN_SITE}/`}>
            comabooks
          </a>
          <div className="l-header-links">
            <a href={`${MAIN_SITE}/order`}>Цены</a>
            <a href="https://www.instagram.com/comabooks/">Отзывы</a>
            <a href={`${MAIN_SITE}/login`}>Войти</a>
          </div>
          <div className="l-header-right">
            <button className="l-btn-order" onClick={handleOrder}>
              Заказать книгу
            </button>
            <button onClick={toggleNav} className="l-btn-burger">
              <MenuIcon />
            </button>
          </div>
        </div>
        <div className={`l-nav ${isNavVisible ? "open" : ""}`}>
          <a href={`${MAIN_SITE}/login`}>Войти</a>
          <a href="https://www.instagram.com/comabooks/">Отзывы</a>
          <a href={`${MAIN_SITE}/policies`}>Условия использования</a>
          <a href={`${MAIN_SITE}/order`}>Цены и вопросы</a>
          <button onClick={handleOrder}>Заказать книгу</button>
        </div>
      </header>

      <main className="l-main">
        {/* Hero */}
        <section className="policy-hero">
          <div className="policy-eyebrow">Правовая информация</div>
          <h1 className="policy-hero-title">
            Документы
            <br />и условия
          </h1>
          <p className="policy-hero-subtitle">
            Политика конфиденциальности, условия использования сайта и
            публичная оферта ТОО «COMABOOKS».
          </p>
        </section>

        {/* Tabs */}
        <div className="policy-tabs" role="tablist">
          {tabOrder.map((doc) => (
            <button
              key={doc.key}
              role="tab"
              aria-selected={activeDoc === doc.key}
              className={`policy-tab ${activeDoc === doc.key ? "active" : ""}`}
              onClick={() => setActiveDoc(doc.key)}
            >
              {doc.label}
            </button>
          ))}
        </div>

        {/* Document */}
        <article className="policy-doc">
          <div className="policy-doc-head">
            <h2 className="policy-doc-title">{current.title}</h2>
            {current.intro && (
              <p className="policy-doc-intro">{current.intro}</p>
            )}
          </div>

          <nav className="policy-toc" aria-label="Содержание">
            <div className="policy-toc-label">Содержание</div>
            <ol>
              {current.sections.map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`}>{s.title}</a>
                </li>
              ))}
            </ol>
          </nav>

          <div className="policy-sections">
            {current.sections.map((s) => (
              <section key={s.id} id={s.id} className="policy-section">
                <h3 className="policy-section-title">{s.title}</h3>
                <div className="policy-section-body">{s.content}</div>
              </section>
            ))}
          </div>
        </article>

        <div className="policy-contact-card">
          <div>
            <div className="policy-contact-eyebrow">Остались вопросы?</div>
            <div className="policy-contact-title">
              Напишите нам — ответим в течение нескольких минут
            </div>
          </div>
          <button className="l-btn-order" onClick={handleOrder}>
            Написать в WhatsApp
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer className="l-footer">
        <div className="l-footer-inner">
          <div className="l-footer-top">
            <a className="l-footer-logo" href={`${MAIN_SITE}/`}>comabooks</a>
            <div className="l-footer-links">
              <a href="https://www.instagram.com/comabooks/">Instagram</a>
              <a href={`${MAIN_SITE}/order`}>Цены и вопросы</a>
              <a href={`${MAIN_SITE}/policies`}>Условия</a>
            </div>
          </div>
          <div className="l-footer-bottom">
            <div>hello@comabooks.org</div>
            <div>ТОО COMABOOKS, 2026</div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Policy;
